module.exports = __webpack_public_path__ + "img/bell_4.abd8bb89.png";